import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InteractionType, KeyValues5, LocalService, PageKey } from '../../../service/local.service';

@Component({
  selector: 'app-business-deductive',
  templateUrl: './business-deductive.component.html',
  styleUrls: ['./business-deductive.component.scss']
})
export class BusinessDeductiveComponent implements OnInit {
  @Input() businesses: KeyValues5[]; @Input() currentBusinessId = '';
  lastChangedBusinesses: KeyValues5[]; interactionType: InteractionType = InteractionType.None;
  @Output() onBusinessUpdated = new EventEmitter();
  constructor(public localService: LocalService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    if (!this.lastChangedBusinesses) {
      this.lastChangedBusinesses = this.businesses;
    }
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType ? routeParams.interactionType : InteractionType.None;
    });
  }

  ngOnChanges(): void {
    if (this.businesses) {
      if (!this.lastChangedBusinesses) {
        this.lastChangedBusinesses = this.businesses;
      }
      if (this.currentBusinessId == '0')
        this.currentBusinessId = '';
      if (this.lastChangedBusinesses.filter(x => x.v5 == 'BU').map(x => x.key).join('-') != this.businesses.filter(x => x.v5 == 'BU').map(x => x.key).join('-')) {
        this.lastChangedBusinesses = this.businesses;
        //this.localService.showInformation(this.localService.languageContent.common.biz_modified);

        if (this.lastChangedBusinesses.filter(x => x.v5 == 'BU').length == 0) {
          this.onBusinessUpdated.emit(false);
          if (this.interactionType == InteractionType.Business)
            this.localService.redirectToSeller();
        } else if (this.currentBusinessId != '' && this.lastChangedBusinesses.filter(x => x.key == this.currentBusinessId && x.v5 == 'BU').length == 0) {
          this.onBusinessUpdated.emit(true);
          if (this.interactionType == InteractionType.Business)
            this.localService.redirectToSeller();
        }
        else {
          if (this.localService.pageKeyBeforeRedirectToSeller != PageKey.None && this.localService.pageKeyBeforeRedirectToSeller != PageKey.Sellers)
            this.localService.onNavigateToPage(this.localService.pageKeyBeforeRedirectToSeller);
          else
            this.onBusinessUpdated.emit(true);
        }
      }
    }
  }
}
